<template>
  <public-page
    :page="page"
    title=""
    ref="publicPage"
    :directBack="false"
    :onlyTrackShow="false"
    :hasHeaderBorder="false"
    :showHeader="false"
    :class="page"
    bgColor="#2669CE"
    @login="loginCb"
  >
    <template #page>
      <section class="ranking-page-body">
        <section
          :class="['page-header-wrapper', type]"
          v-lazy:background-image="getBgUrl"
        >
          <div :class="['header', type]">
            <img
              class="logo"
              @click="back"
              :src="require(`@/assets/images/activities/ranking/logo.png`)"
              v-if="type === 'page'"
            />
            <div class="share" @click="clickShare">
              {{ $t('ranking.share_points') }}
            </div>
          </div>
          <div class="title-placeholder"></div>
          <div class="desc">{{ topRuleText }}</div>
          <button
            :class="['topup-btn', type, activityIsEnded ? 'hidden' : '']"
            @click="topUp"
          >
            {{
              loginStatus ? $t('ranking.recharge_points') : $t('ranking.log_in')
            }}
          </button>
          <p class="rules" @click="gotoRules" v-if="page !== 'ranking-rules'">
            {{ $t('ranking.event_rules') }}
          </p>
        </section>
        <slot name="body"></slot>

        <section class="ranking-shareSheet-wrapper">
          <MobileShare
            ref="mobileShare"
            moduleName="ranking"
            getContainer=".ranking-public-share"
          />
        </section>
      </section>
    </template>
  </public-page>
</template>
<script>
  import PublicPage from '@/components/PublicPage'
  import { mapState } from 'vuex'
  import { share_show } from '../../firebase'
  import { shareSuccess } from '@/pages/firebase'
  import { textFormat } from '@/utils/pluralRules.js'
  import { MobileShare } from '@/components/PublicShare/index'

  export default {
    components: {
      PublicPage,
      MobileShare,
    },
    props: {
      page: {
        default: '',
        type: String,
      },
      type: {
        default: '',
        type: String,
      },
      activityInfos: {
        default: () => {},
        type: Object,
      },
      havePointsUserCount: {
        default: 0,
        type: Number,
      },
      userPoints: {
        default: 0,
        type: Number,
      },
      allRankingList: {
        default: () => [],
        type: Array,
      },
      joinRankingAllUsers: {
        default: () => [],
        type: Array,
      },
    },
    computed: {
      ...mapState(['userInfo']),
      getBgUrl() {
        const { extraInfo = {} } = this.activityInfos || {}
        const { h5Pic, popPic } = extraInfo
        if (this.type === 'popup') {
          return popPic
        }
        return h5Pic
      },
      activityIsEnd() {
        return true
      },
      // 顶部规则文案展示
      topRuleText() {
        // 活动已结束
        if (this.activityIsEnded) {
          // 已上榜
          if (this.myselfIsInRanking) {
            return this.$t('ranking.subtitle_2')
          } else {
            // 未上榜
            return this.$t('ranking.subtitle_6')
          }
        }
        // 未登录
        if (!this.loginStatus) {
          return this.$t('ranking.subtitle_1')
        }
        const {
          activityInfos = {},
          myselfRankingInfo = {},
          userPoints = 0,
        } = this
        // integral: 上榜最小积分数
        const { extraInfo = {} } = activityInfos
        const { integral = 0 } = extraInfo
        const { points = 0, rank = 0 } = myselfRankingInfo
        // 如果我是第一名
        if (this.myselfIsFirst) {
          // 如果没有上榜，展示差多少积分上榜的文案
          if (!this.myselfIsInRanking) {
            return this.textFormat(
              this.$t('ranking.subtitle_5'),
              integral - userPoints
            )
          }
          // 如果上榜了，则不展示文案
          return ''
        }
        // - 未上榜
        // 自动当前积分小于上榜最小积分数视为未上榜
        if (!this.myselfIsInRanking) {
          let diffPoints = integral - userPoints
          // 上榜人数达到最大，未上榜
          if (this.rankingUsersIsMax) {
            diffPoints = this.lastInRankingUserInfo?.points - userPoints
          }
          return this.textFormat(this.$t('ranking.subtitle_5'), diffPoints || 0)
        } else {
          const { havePointsUserCount = 0 } = this
          // 目前排名
          const currentRank = rank
          // 超过y%用户: {【活动周期内当前国家获得积分的用户量】-x}/【活动周期内当前国家获得积分的用户量】
          const aboveRate = Number(
            ((havePointsUserCount - currentRank) / havePointsUserCount || 0) *
              100
          ).toFixed(2)
          // 相差积分: 【排行榜中获得奖励的最后一名用户积分数量】-【当前用户积分数量】
          // 获得奖励的最后一名用户信息
          const lastGetAwardUserInfos = this.lastGetAwardsUserInfo
          const { coupon = {}, points: lastGetAwardPoints } =
            lastGetAwardUserInfos || {}

          // - 已上榜-并获得奖品
          if (this.myselfMayGetAward) {
            const text = this.handleInRankingGetAwardText(
              currentRank,
              aboveRate,
              currentRank - 1
            )
            return this.textFormat(text, this.previousUserInfo?.points - points)
          } else {
            // - 已上榜-未获得奖品
            const couponFormatInfos = this.formatCoupon(coupon) || {}
            const {
              currency = '',
              couponDisplayName = '',
              couponType,
            } = couponFormatInfos
            const text = this.handleInRankingNoAwardText(
              currentRank,
              aboveRate,
              couponType * 1 === 1 ? currency : '',
              couponDisplayName
            )
            return this.textFormat(text, lastGetAwardPoints - points)
          }
        }
      },
      // "我"在排行榜中的信息
      myselfRankingInfo() {
        if (!this.loginStatus) return {}
        const { userInfo = {} } = this
        return (
          (this.joinRankingAllUsers.filter(
            (item) => item.kicoinId === userInfo?.kicoinId
          ) || [])[0] || {}
        )
      },
      // ”我“是否获奖
      myselfMayGetAward() {
        const { myselfRankingInfo = {} } = this
        if (myselfRankingInfo.coupon && myselfRankingInfo.coupon.id) {
          return true
        }
        return false
      },
      loginStatus() {
        const { kicoinId, kicoinToken } = this.userInfo || {}
        if (kicoinId && kicoinToken) {
          return true
        }
        return false
      },
      myselfIsFirst() {
        const { myselfRankingInfo = {} } = this
        return myselfRankingInfo.rank === 1
      },
      // "我"是否上榜：“我的”积分如果大于等于最小上榜积分，则为上榜
      myselfIsInRanking() {
        const { myselfRankingInfo = {}, activityInfos = {} } = this
        const { points = 0 } = myselfRankingInfo
        if (myselfRankingInfo && Object.keys(myselfRankingInfo).length === 0) {
          return false
        }
        // integral: 上榜最小积分数
        const { extraInfo = {} } = activityInfos
        const { integral = 0 } = extraInfo
        if (points >= integral) {
          return true
        }
        return false
      },
      // 获得奖励的最后一名用户信息
      lastGetAwardsUserInfo() {
        const { allRankingList = [] } = this
        const allGetAwardsUser =
          allRankingList.filter((item) => item.coupon && item.coupon.id) || []

        return allGetAwardsUser[allGetAwardsUser.length - 1] || {}
      },
      // '我的'前一个用户
      previousUserInfo() {
        const { myselfRankingInfo = {} } = this
        const { allRankingList = [] } = this
        const { rank } = myselfRankingInfo
        const previousUsers =
          allRankingList.filter((item) => item.rank === rank - 1) || []
        return previousUsers[previousUsers.length - 1]
      },
      // 活动是否已结束
      activityIsEnded() {
        const { activityInfos = {} } = this
        // 活动状态 1待激活 2已激活 3已停止 4已下线
        const { extraInfo = {} } = activityInfos
        // computeStartTime 积分计算开始时间
        const { computeEndTime } = extraInfo
        const currentTs = +new Date() / 1000
        return currentTs > computeEndTime
      },
      // 榜单是否已满
      rankingUsersIsMax() {
        const { activityInfos = {}, allRankingList = [] } = this
        const { extraInfo = {} } = activityInfos
        const { number = 0 } = extraInfo
        if (allRankingList.length >= number) {
          return true
        }
        return false
      },
      // 最后一个上榜的用户信息
      lastInRankingUserInfo() {
        return this.allRankingList[this.allRankingList.length - 1] || {}
      },
    },
    data() {
      return {
        pageConfig: {
          headerBgUrl: require(`@/assets/images/activities/ranking/header-bg.png`),
        },
        textFormat: textFormat,
      }
    },
    mounted() {
      const { source = '', channelId } = this.$route.query
      if (source === 'share') {
        shareSuccess({ page: this.page, share_name: channelId })
      }
    },
    methods: {
      gotoRules() {
        this.$emit('clickRules')
      },
      back() {
        this.$router_push({
          path: '/',
        })
      },
      clickShare() {
        share_show({ page: this.page })
        if (this.$refs.mobileShare) {
          this.$refs.mobileShare.switch()
          this.$refs.mobileShare.setPageName('ranking')
        }
      },
      loginCb(res = {}) {
        this.$emit('loginCb', res)
      },
      showLoginPopup() {
        const { activityId } = this.activityInfos || {}
        this.$refs.publicPage &&
          this.$refs.publicPage.showLoginPopup({
            type: 'activity',
            act_id: activityId,
          })
      },
      topUp() {
        this.$emit('topup')
      },
      getRankingPosition(rank) {
        return (
          (this.allRankingList.filter((item) => item.rank === rank) || [])[0] ||
          {}
        )
      },
      // 处理上榜&未发奖文案
      handleInRankingNoAwardText(rankingNum, rate, currency, money) {
        const text = this.$t('ranking.subtitle_4') || ''
        return (
          text
            .replace('{rankingNum}', rankingNum)
            .replace('{number}', rate)
            .replace('{currency}', currency)
            .replace('{money}', money) || ''
        )
      },
      // 处理上榜&获奖文案
      handleInRankingGetAwardText(rankingNum, rate, rankingNum1) {
        const text = this.$t('ranking.subtitle_3') || ''
        return (
          text
            .replace('{rankingNum}', rankingNum)
            .replace('{number}', rate)
            .replace('{rankingNum}', rankingNum1) || ''
        )
      },
      formatCoupon(coupon) {
        const res = { ...coupon }
        const { couponType, couponDiscount = 0, couponPrice = 0 } = res || {}
        // couponType 1 立减券 2折扣券
        if (couponType * 1 === 1) {
          res.couponDisplayName = couponPrice
        } else {
          res.couponDisplayName = 100 - couponDiscount * 1 + '% OFF'
        }
        return res
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
